import { useContext, useMemo } from "react"
import { AutoComplete } from "components/Form"
import { semesterAndYearOptions } from "keys/years"
import { CreateAssessmentsContext } from "../CreateAssessmentsContext"

const useYearFilter = () => {
    const { year, setYear } = useContext(CreateAssessmentsContext)

    const yearFilter = useMemo(() => ({
        name: "school_year",
        component: AutoComplete,
        options: semesterAndYearOptions,
        size: "small",
        width: 160,
        hideClear: true,
        input: {
            value: year,
            onChange: setYear
        },
        placeholder: "שנת לימודים"
    }), [year])

    return yearFilter
}

export default useYearFilter
